const actions = {
    setInfos({commit},getInfo) {
      commit('setInfos',getInfo)
  }
}
export default actions  